(function () {
  'use strict';

  function snapUp(value, step, min) {
    if (step <= 1) return Math.max(value, min || 1);
    var snapped = Math.ceil(value / step) * step;
    return Math.max(snapped, Math.ceil((min || 1) / step) * step);
  }

  function isValid(value, min, step) {
    return value >= min && (step <= 1 || value % step === 0);
  }

  function findQtyInput(form) {
    return form.querySelector('input[name="quantity"]') ||
      (form.id ? document.querySelector('input[name="quantity"][form="' + form.id + '"]') : null);
  }

  function showError(anchorEl, message) {
    var container = anchorEl.closest('.product-form__quantity, .quantity') || anchorEl.parentNode;
    var el = container.querySelector('.pln-qty-err');
    if (!el) {
      el = document.createElement('p');
      el.className = 'pln-qty-err';
      Object.assign(el.style, { color: '#DC2626', fontSize: '13px', fontWeight: '700', margin: '8px 0 0', lineHeight: '1.4' });
      container.appendChild(el);
    }
    el.textContent = message;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 7000);
  }

  // ── ATC: block invalid quantities on product page ─────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[type="submit"].product-form__submit, button[type="submit"][name="add"]');
    if (!btn) {
      btn = e.target.closest('button[type="submit"]');
      if (!btn || !btn.closest('product-form')) return;
    }
    var productFormEl = btn.closest('product-form');
    if (!productFormEl) return;
    var form = productFormEl.querySelector('form[id]') || productFormEl.querySelector('form');
    if (!form) return;
    var qtyInput = findQtyInput(form);
    if (!qtyInput) return;

    var qty  = parseInt(qtyInput.value, 10);
    var min  = parseInt(qtyInput.getAttribute('min') || qtyInput.dataset.min || '1', 10) || 1;
    var step = parseInt(qtyInput.getAttribute('step') || '1', 10) || 1;
    if (!isNaN(qty) && isValid(qty, min, step)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    var corrected = (isNaN(qty) || qty < min) ? min : snapUp(qty, step, min);
    qtyInput.value = corrected;
    showError(qtyInput, (isNaN(qty) || qty < min)
      ? 'Mindestbestellmenge: ' + min + ' Stück (auf ' + corrected + ' gesetzt – bitte erneut klicken).'
      : 'Nur Vielfache von ' + step + ' erlaubt (auf ' + corrected + ' gesetzt – bitte erneut klicken).');
  }, true);

  // ── Cart inputs: read pln-step/pln-min from Liquid, correct on blur/change ──
  function enhanceCartInput(input) {
    if (input.dataset.plnCartEnhanced) return;
    var step = parseInt(input.dataset.plnStep || '1', 10) || 1;
    var min  = parseInt(input.dataset.plnMin  || '1', 10) || 1;
    if (step <= 1 && min <= 1) return;
    input.dataset.plnCartEnhanced = '1';

    function correct() {
      var raw = parseInt(input.value, 10);
      if (isNaN(raw) || raw < 1) { input.value = min; return; }
      if (!isValid(raw, min, step)) {
        var c = snapUp(raw, step, min);
        input.value = c;
        showError(input, step > 1 && raw % step !== 0
          ? 'Nur Vielfache von ' + step + ' erlaubt – auf ' + c + ' angepasst.'
          : 'Mindestmenge: ' + min + ' – auf ' + c + ' angepasst.');
      }
    }

    input.addEventListener('blur', correct);
    var correcting = false;
    input.addEventListener('change', function () {
      if (correcting) return;
      correcting = true;
      setTimeout(function () { correct(); correcting = false; }, 0);
    });
  }

  function enhanceAllCartInputs() {
    document.querySelectorAll('input.quantity__input[data-pln-step], input.quantity__input[data-pln-min]')
      .forEach(enhanceCartInput);
  }

  // ── Checkout guard: correct cart via API if needed ────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;

    // Collect invalid cart inputs from DOM
    var updates  = {};
    var messages = [];

    document.querySelectorAll('input.quantity__input[data-pln-step], input.quantity__input[data-pln-min]')
      .forEach(function (input) {
        var step    = parseInt(input.dataset.plnStep || '1', 10) || 1;
        var min     = parseInt(input.dataset.plnMin  || '1', 10) || 1;
        var qty     = parseInt(input.value, 10);
        var varId   = input.dataset.quantityVariantId;
        if (isNaN(qty) || !varId) return;
        if (!isValid(qty, min, step)) {
          var c = snapUp(qty, step, min);
          updates[varId] = c;
          messages.push(qty + ' → ' + c);
          input.value = c; // fix DOM immediately
        }
      });

    if (!Object.keys(updates).length) return; // all valid, let checkout proceed normally

    // Block and correct
    e.preventDefault();
    e.stopImmediatePropagation();

    var footer = btn.closest('.cart__footer, .cart-drawer__footer') || btn.parentNode;
    var errEl  = footer.querySelector('.pln-cart-err');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.className = 'pln-cart-err';
      Object.assign(errEl.style, { color: '#DC2626', fontWeight: '700', fontSize: '13px', margin: '12px 0 0', textAlign: 'center', lineHeight: '1.5' });
      btn.insertAdjacentElement('beforebegin', errEl);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () {
        errEl.textContent = 'Menge(n) korrigiert (' + messages.join(', ') + '). Bitte erneut auf Checkout klicken.';
        errEl.hidden = false;
        errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        errEl.textContent = 'Fehler beim Korrigieren – bitte Seite neu laden.';
        errEl.hidden = false;
      });

  }, true);

  // ── Init + re-enhance on cart changes ─────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAllCartInputs);
  } else {
    enhanceAllCartInputs();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[aria-controls="CartDrawer"], [data-drawer-open]')) {
      setTimeout(enhanceAllCartInputs, 400);
    }
  });

  document.addEventListener('cart:refresh', function () { setTimeout(enhanceAllCartInputs, 300); });
  document.addEventListener('cart:updated', function () { setTimeout(enhanceAllCartInputs, 300); });

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.querySelector && node.querySelector('input[data-pln-step], input[data-pln-min]')) {
            setTimeout(enhanceAllCartInputs, 100);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
